'use client';

import { getQueryClient } from '@/lib/query-client';
import { store } from '@/store';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

interface ClientProviderProps {
  children: React.ReactNode;
}

export default function BaseProvider({ children }: ClientProviderProps) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>{children}</Provider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}
